export * from "./catalogueFilter";

import { createPinia } from "pinia";

export const store = createPinia();
